// import ApiService from '@/helpers/api.service';
// const API = new ApiService();
import ApiService2 from "@/helpers/api.service.ext";
const API2 = new ApiService2();
const ELOAD_B2B_ENDPOINT = "/eload";
const S3_FOLDER = "eload-b2b";
import moment from "moment";
import { Storage } from "aws-amplify";

export const state = {
  eloadB2BRequests: [],
  eloadB2BRequestsTotal: 0,
  eloadB2BRequestDetails: {},
  eloadB2BUsers: [],
  eloadB2BBanks: [],
  eloadB2BPeddlrBanks: [],
  eloadB2BDefaultRebate: 0,
  errors: null,
};

export const mutations = {
  UPDATE_ELOAD_B2B_REQUESTS(state, value) {
    state.eloadB2BRequests = value;
  },
  UPDATE_ELOAD_B2B_REQUESTS_TOTAL(state, total) {
    state.eloadB2BRequestsTotal = total;
  },
  UPDATE_ELOAD_B2B_REQUEST_DETAILS(state, value) {
    state.eloadB2BRequestDetails = value;
  },
  UPDATE_ELOAD_B2B_USERS(state, value) {
    state.eloadB2BUsers = value;
  },
  UPDATE_ELOAD_B2B_REBATE(state, value) {
    state.eloadB2BDefaultRebate = value;
  },
  UPDATE_ELOAD_B2B_BANKS(state, value) {
    state.eloadB2BBanks = value;
  },
  UPDATE_ELOAD_B2B_PEDDLR_BANKS(state, value) {
    state.eloadB2BPeddlrBanks = value;
  },
  SET_PROD_ERRORS(state, errors) {
    state.errors = errors;
  },
};

export const actions = {
  getEloadB2BRequests(context, params) {
    return new Promise((resolve, reject) => {
      API2.post(`${ELOAD_B2B_ENDPOINT}/b2b-requests`, params)
        .then(({ data }) => {
          context.commit("UPDATE_ELOAD_B2B_REQUESTS", data.message.rows);
          context.commit("UPDATE_ELOAD_B2B_REQUESTS_TOTAL", data.message.pageInfo.total);
          resolve();
        })
        .catch(({ response }) => {
          context.commit("SET_PROD_ERRORS", response.message);
          reject();
        });
    });
  },
  getEloadB2BRequestDetails(context, params) {
    return new Promise((resolve, reject) => {
      API2.post(`${ELOAD_B2B_ENDPOINT}/b2b-request-details`, params)
        .then(({ data }) => {
          context.commit("UPDATE_ELOAD_B2B_REQUEST_DETAILS", data.message.request);
          resolve();
        })
        .catch(({ response }) => {
          context.commit("SET_PROD_ERRORS", response.message);
          reject();
        });
    });
  },
  async saveEloadB2BRequest(context, params) {
    return new Promise((resolve, reject) => {
      API2.post(`${ELOAD_B2B_ENDPOINT}/b2b-save-request`, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("SET_PROD_ERRORS", response.message);
          reject();
        });
    });
  },
  async getEloadB2BUsers(context, params) {
    return new Promise((resolve, reject) => {
      API2.post(`${ELOAD_B2B_ENDPOINT}/b2b-users`, params)
        .then(({ data }) => {
          context.commit("UPDATE_ELOAD_B2B_USERS", data.message.rows);
          context.commit("UPDATE_ELOAD_B2B_REBATE", data.message.defaultRebate);
          resolve();
        })
        .catch(({ response }) => {
          context.commit("SET_PROD_ERRORS", response.message);
          reject();
        });
    });
  },
  getEloadB2BBanks(context, params) {
    return new Promise((resolve, reject) => {
      API2.post(`${ELOAD_B2B_ENDPOINT}/b2b-banks`, params)
        .then(({ data }) => {
          context.commit("UPDATE_ELOAD_B2B_BANKS", data.message.rows.senderBanks);
          context.commit("UPDATE_ELOAD_B2B_PEDDLR_BANKS", data.message.rows.peddlrBanks);
          resolve();
        })
        .catch(({ response }) => {
          context.commit("SET_PROD_ERRORS", response.message);
          reject();
        });
    });
  },
  async uploadEloadB2BDepositImg(context, params){
    return new Promise((resolve, reject) => {
      var allowedType = ["jpg","jpeg","png"];
      if(params.type && !allowedType.includes(params.type.toLowerCase())){
        reject("Filetype not allowed");
        return;
      }

      var metadata =  {
        customPrefix: {
          public: ''
        },
        expires: moment().add(365, 'days').toDate(),
      }

      if(params.type == 'jpg' || params.type == 'jpeg'){
        metadata['contentType'] = 'image/jpeg';
      }
      if(params.type == 'png'){
        metadata['contentType'] = 'image/png';
      }

      let s3_loc;
      if((params?.subFolder??null) != null){
        s3_loc = `${S3_FOLDER}/${params.subFolder}/${params.filename}`
      }else{
        s3_loc = `${S3_FOLDER}/deposit/${params.filename}`
      }

      // console.log(">>>>>>>",metadata['contentType']);
      Storage.put(s3_loc, params.base64, metadata)
        .then(stored => {
            console.log(stored);
            resolve(stored.key.replace(params.folder + "/", ""));
        })
        .catch(err => {
            console.log(err);
            reject(err);
        });
    });
  },
  postApprovedRequest(context, params) {
    return new Promise((resolve, reject) => {
      API2.post(`${ELOAD_B2B_ENDPOINT}/b2b-request-approved`, params)
        .then(({ data }) => {
          if(data?.status == "ok"){
            resolve(data);
          }else{
            reject(data);
          }
        })
        .catch(({ response }) => {
          context.commit("SET_PROD_ERRORS", response.message);
          reject();
        });
    });
  },
  postRejectedRequest(context, params) {
    return new Promise((resolve, reject) => {
      API2.post(`${ELOAD_B2B_ENDPOINT}/b2b-request-rejected`, params)
        .then(({ data }) => {
          if(data?.status == "ok"){
            resolve(data);
          }else{
            reject(data);
          }
        })
        .catch(({ response }) => {
          context.commit("SET_PROD_ERRORS", response.message);
          reject();
        });
    });
  },
  clearRequestDetails(context){
    context.commit("UPDATE_ELOAD_B2B_REQUEST_DETAILS", {});
  }
};
